var map = {
	"./taskIcon0.png": 1809,
	"./taskIcon1.png": 1864,
	"./taskIcon2.png": 8723,
	"./taskIcon3.png": 3498,
	"./taskIcon4.png": 1445,
	"./taskIcon5.png": 8556,
	"./taskIcon6.png": 3383,
	"./taskIcon7.png": 5694,
	"./taskIcon8.png": 4585,
	"./taskIcon9.png": 9760
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3806;